export default {
	"type": "form",
	"tags": [],
	"owner": "5b6b34b5339cfc558d129a9a",
	"components": [
		{
			"clearOnHide": false,
			"key": "panel",
			"input": false,
			"title": "DEALER REQUEST STATUS",
			"theme": "primary",
			"tableView": false,
			"components": [
				{
					"clearOnHide": false,
					"label": "Columns",
					"input": false,
					"tableView": false,
					"key": "panelPanelColumns",
					"columns": [
						{
							"components": [
								{
									"autofocus": false,
									"input": true,
									"tableView": true,
									"inputType": "text",
									"inputMask": "",
									"label": "Current Status",
									"key": "panelPanelColumnsCurrentStatus",
									"placeholder": "",
									"prefix": "",
									"suffix": "",
									"multiple": false,
									"defaultValue": "",
									"protected": false,
									"unique": false,
									"persistent": true,
									"hidden": false,
									"clearOnHide": true,
									"spellcheck": true,
									"validate": {
										"required": false,
										"minLength": "",
										"maxLength": "",
										"pattern": "",
										"custom": "",
										"customPrivate": false
									},
									"conditional": {
										"show": "",
										"when": null,
										"eq": ""
									},
									"type": "textfield",
									"labelPosition": "top",
									"inputFormat": "plain",
									"tags": [],
									"properties": {},
									"disabled": true
								},
								{
									"autofocus": false,
									"input": true,
									"tableView": true,
									"label": "Sales Rep for Requesting Dealer:",
									"key": "salesRep",
									"placeholder": "",
									"data": {
										"values": [
										],
										"json": "",
										"url": "",
										"resource": "",
										"custom": "values = data['salesRepValues']"
									},
									"dataSrc": "custom",
									"valueProperty": "",
									"defaultValue": "",
									"refreshOn": "",
									"filter": "",
									"authenticate": false,
									"template": "<span>{{ item.label }}</span>",
									"multiple": false,
									"protected": false,
									"unique": false,
									"persistent": true,
									"hidden": false,
									"clearOnHide": true,
									"validate": {
										"required": false
									},
									"type": "select",
									"labelPosition": "top",
									"tags": [],
									"conditional": {
										"show": "",
										"when": null,
										"eq": ""
									},
									"properties": {},
									"lockKey": true
								},
								{
									"autofocus": false,
									"input": true,
									"tableView": true,
									"label": "Price List:",
									"key": "priceList",
									"placeholder": "",
									"data": {
										"values": [
										],
										"json": "",
										"url": "",
										"resource": "",
										"custom": "values = data['priceListValues']"
									},
									"dataSrc": "custom",
									"valueProperty": "",
									"defaultValue": "",
									"refreshOn": "",
									"filter": "",
									"authenticate": false,
									"template": "<span>{{ item.label }}</span>",
									"multiple": false,
									"protected": false,
									"unique": false,
									"persistent": true,
									"hidden": false,
									"clearOnHide": true,
									"validate": {
										"required": false
									},
									"type": "select",
									"labelPosition": "top",
									"tags": [],
									"conditional": {
										"show": "",
										"when": null,
										"eq": ""
									},
									"properties": {},
									"lockKey": true
								},
								{
									"autofocus": false,
									"input": true,
									"tableView": true,
									"inputType": "text",
									"inputMask": "",
									"label": "ERP Customer ID",
									"key": "erpCustID",
									"placeholder": "",
									"prefix": "",
									"suffix": "",
									"multiple": false,
									"defaultValue": "",
									"protected": false,
									"unique": false,
									"persistent": true,
									"hidden": false,
									"clearOnHide": true,
									"spellcheck": true,
									"validate": {
										"required": false,
										"minLength": "",
										"maxLength": "",
										"pattern": "",
										"custom": "",
										"customPrivate": false
									},
									"conditional": {
										"show": "",
										"when": null,
										"eq": ""
									},
									"type": "textfield",
									"labelPosition": "top",
									"inputFormat": "plain",
									"tags": [],
									"properties": {}
								}
							],
							"width": 6,
							"offset": 0,
							"push": 0,
							"pull": 0
						},
						{
							"components": [
								{
									"autofocus": false,
									"input": true,
									"tableView": true,
									"inputType": "radio",
									"label": "Select New Status",
									"key": "panelPanelColumnsSelectNewStatus",
									"values": [],
									"defaultValue": "",
									"protected": false,
									"fieldSet": false,
									"persistent": true,
									"hidden": false,
									"clearOnHide": true,
									"validate": {
										"required": true,
										"custom": "",
										"customPrivate": false
									},
									"type": "radio",
									"labelPosition": "top",
									"optionsLabelPosition": "right",
									"tags": [],
									"conditional": {
										"show": "",
										"when": null,
										"eq": ""
									},
									"properties": {}
								}
							],
							"width": 6,
							"offset": 0,
							"push": 0,
							"pull": 0
						}
					],
					"type": "columns",
					"hideLabel": true,
					"tags": [],
					"conditional": {
						"show": "",
						"when": null,
						"eq": ""
					},
					"properties": {},
					"lockKey": true
				}
			],
			"type": "panel",
			"breadcrumb": "default",
			"hideLabel": false,
			"tags": [],
			"conditional": {
				"show": "",
				"when": null,
				"eq": ""
			},
			"properties": {}
		},
		{
			"autofocus": false,
			"input": true,
			"label": "Update",
			"tableView": false,
			"key": "submit",
			"size": "md",
			"leftIcon": "",
			"rightIcon": "",
			"block": false,
			"action": "submit",
			"disableOnInvalid": false,
			"theme": "primary",
			"type": "button",
			"tags": [],
			"conditional": {
				"show": "",
				"when": null,
				"eq": ""
			},
			"properties": {}
		}
	],
	"revisions": "",
	"_vid": 0,
	"_id": "5b85af591143312c1cb86a79",
	"title": "Required Approval",
	"display": "form",
	"access": [
		{
			"roles": [
				"5b6b3f6dd004cef5e6884aad",
				"5b6b3f6dd004cea80c884aae",
				"5b6b3f6dd004ce196d884aaf"
			],
			"type": "read_all"
		}
	],
	"submissionAccess": [],
	"settings": {},
	"name": "requiredApproval",
	"path": "requiredapproval",
	"project": "5b6b3f6dd004ce54a3884aac",
	"created": "2018-08-28T20:23:53.168Z",
	"modified": "2018-08-31T12:27:01.827Z",
	"machineName": "ecrnfrymdpgxbsc:requiredApproval"
}